export const pinLogin = {
  "title": "ป้อนรหัส PIN",
  "checkingPin": "กำลังตรวจสอบ PIN...",
  "adminLoginLink": "สลับไปที่การเข้าสู่ระบบของผู้ดูแลระบบ"
};
